<template>
  <div v-qa="'navigation'">
    <nuxt-link
      v-for="{path, text} in links"
      :key="path"
      v-qa="`nav_link_${path}`"
      :to="localePath(path)"
      class="link">
      {{ text }}
    </nuxt-link>
  </div>
</template>

<script>
import { WEB_ROUTES } from '~/app/shared/utils/web-config';

export default {
  name: 'Navigation',

  computed: {
    links() {
      return [
        { path: WEB_ROUTES.HOW_TO_GET, text: this.$t('header.how-to-get') },
        { path: WEB_ROUTES.HOW_TO_PAY, text: this.$t('header.how-to-pay') },
        { path: WEB_ROUTES.DOCUMENTS, text: this.$t('header.documents') },
        { path: WEB_ROUTES.FAQ, text: this.$t('header.faq') },
        { path: WEB_ROUTES.OFFICES, text: this.$t('header.offices') },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.link {
  margin-right: 10px;
  color: map-get($map: $colors, $key: text);

  @include not-desktop {
    margin-bottom: 30px;
    display: block;
    font-weight: 600;
  }

  @include desktop {
    margin-top: 3px;
    font-size: 14px;
  }

  &:last-child {
    margin-right: 0;
    margin-bottom: 0;
  }

  &:after {
    display: block;
    width: 100%;
    height: 2px;
    background: map-get($map: $colors, $key: secondary);
    transform: scaleX(0);
    transform-origin: left;
    transition: all 0.3s;

    @include desktop {
      content: '';
    }
  }

  &.active-url {
    font-weight: 700;

    @include not-desktop {
      color: map-get($map: $colors, $key: ternary);
    }

    &:after {
      transform: scaleX(1);
    }
  }

  &:hover {
    text-decoration: none;

    &:after {
      transform: scaleX(1);
    }
  }
}
</style>
